export enum ProspectSearchAutoCompleteFields {
    JOB_COMPANY_NAME = 'job_company_name',
    LOCATION_NAME = 'location_name',
    JOB_TITLE_NEW = 'job_title_new',
    /** @deprecated from frontend */
    JOB_TITLE = 'job_title',
}
